import { render, staticRenderFns } from "./PromotionOtherList.vue?vue&type=template&id=f8944aa0&scoped=true"
import script from "./PromotionOtherList.vue?vue&type=script&lang=js"
export * from "./PromotionOtherList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8944aa0",
  null
  
)

export default component.exports